/*
 * Copyright (c) 2019 - Indigen Solutions
 * Authors:
 *   - Bichoy Messiha <bm@indigen.com>
 * NOTICE: All information contained herein is, and remains
 * the property of Indigen Solutions and its suppliers,
 * if any.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Indigen Solutions.
 */

import { forEach, get, map } from "lodash";
import { Services } from "./Services";
import { isTodayAfter2025 } from "../helpers/naf.helper";

export class ConventionApi {
    constructor(api) {
        this._conventions = {};
        this._allConventions = [];
        this.api = api;
    }

    /**
     *
     * @param conventionId
     * @param variantNumber
     */
    async getByConventionId(conventionId, variantNumber, forceUpdate = false) {
        if (this._conventions[`${conventionId}:${variantNumber}`] && !forceUpdate) {
            return this._conventions[`${conventionId}:${variantNumber}`];
        }
        const convention = await this.api.get(`/convention/${conventionId}/d${variantNumber}`);
        convention.title = this.getTitle(convention);

        const availableCodes = get(convention, "cspConfig.availableCodes", []);
        convention.cspConfig = {
            ...convention.cspConfig,
            availableCodes: map(availableCodes, code => "csp-" + code.toLowerCase()),
        };
        this._conventions[`${conventionId}:${variantNumber}`] = convention;
        return convention;
    }

    /**
     *
     */
    async getSearchable() {
        const apenafs = await Services.api.ca.getAllApenafs();
        const result = await this.api.get(`/convention/_searchable`);
        const conventions = map(result.ccnSearchableList, c => {
            return {
                ...c,
                title: this.getTitle(c),
                activitiesTitles: this.getActivitiesTitles(c, apenafs),
            };
        });
        return {
            conventions,
            updatedAt: result.updatedAt,
        };
    }

    /**
     *
     */
    async getPublicSearchable() {
        const result = await this.api.get(`/convention-public/_searchable`);
        const conventions = map(result.ccnSearchableList, c => {
            return {
                ...c,
                title: this.getTitle(c),
            };
        });
        return {
            conventions,
            updatedAt: result.updatedAt,
        };
    }

    /**
     *
     */
    async getSearchablePanorama(query = {}) {
        const result = await this.api.get(`/convention/panorama/search`, query);
        return {
            conventions: result._embedded.conventionVariants
                ? result._embedded.conventionVariants
                : [],
            numberOfPages: result.page ? result.page.totalPages : 0,
            totalConventions: result.page ? result.page.totalElements : 0,
        };
    }

    /**
     *
     */
    async getSearchablePanoramaChildrenByParentConventionId(query = {}) {
        return await this.api.get(`/convention/all-children-by-parentId`, query);
    }

    /**
     *
     */
    async getSearchablePanoramaExport(query = {}) {
        return await this.api.get(`/convention/panorama/export`, query);
    }

    getTitle(convention) {
        if (convention.isDenounced) {
            return `${convention.title} - Dénoncée`;
        }
        if (convention.isReplaced) {
            return `${convention.title} - Remplacée`;
        }
        return convention.title;
    }

    /**
     *
     * @param convention
     */
    getActivitiesTitles(convention, apenafs) {
        let titles = "";
        forEach(convention.activitiesCode.split(" "), code => {
            const apenaf = apenafs[code];
            if (apenaf && (isTodayAfter2025() || apenaf.type != "N2025")) {
                titles += " " + apenaf.label;
            }
        });
        return titles;
    }
}
